import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import Chip, { ChipProps } from '@mui/material/Chip';
import { CandidateBatchStatus } from 'generated-graphql/types';
import React from 'react';

const getStatusChipProps = (status: CandidateBatchStatus): ChipProps => {
  switch (status) {
    case CandidateBatchStatus.Live:
    case CandidateBatchStatus.FinishedRankingCandidates:
      return {
        label: 'Live',
        color: 'success',
        icon: (
          <FiberManualRecordIcon
            fontSize="small"
            style={{
              fontSize: '0.6rem'
            }}
          />
        )
      };
    case CandidateBatchStatus.Paused:
    case CandidateBatchStatus.Archived:
      return {
        label: 'Archived',
        color: 'error',
        icon: <DeleteOutlinedIcon fontSize="small" color="error" />
      };

    case CandidateBatchStatus.Draft:
      return {
        label: 'Draft',
        color: 'default',
        icon: <EditIcon fontSize="small" />,
        sx: { color: 'customGrey.dark', backgroundColor: 'customGrey.light' }
      };
    case CandidateBatchStatus.Created:
    case CandidateBatchStatus.PreProcessing:
    case CandidateBatchStatus.ReadyToProcess:
    case CandidateBatchStatus.RankingCandidates:
      return {
        label: 'Processing',
        color: 'info',
        icon: <HourglassEmptyIcon fontSize="small" />,
        sx: { color: 'customGrey.dark', backgroundColor: 'customGrey.light' }
      };
    default:
      return {
        label: status || 'Unknown',
        color: 'default'
      };
  }
};

type Props = {
  status?: CandidateBatchStatus | null;
};

export const CandidateBatchStatusChip: React.FC<Props> = ({ status }) => {
  if (!status) {
    return null;
  }

  const chipProps = getStatusChipProps(status);

  return <Chip {...chipProps} />;
};
